import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const VALID_PATHS = [
  "/Home",
  "/dashboard",
  "/start-assessment",
  "/review-assessment",
  "/continue-assessment",
  "/Suggested-interventions",
  "/Goals",
  "/Reminder",
  "/Editgoal",
  "/help",
  "/Library",
  "/summarypage",
  "/Interventions",
  "/FeedbackPage",
  "/updategoal",
  "/goalsetdownload",
  // "/goalreview-history" is listed BEFORE "/goalreview" so the longer,
  // more specific path always wins the match in stripPath().
  "/goalreview-history",
  "/goalreview",
  "/demographics-data",
  "/background-info-data",
  "/historical-pathway",
  "/client-history",
];

const stripPath = (pathname) => {
  const path = VALID_PATHS.find((p) => pathname === p || pathname.startsWith(p + "/"));
  return path || pathname;
};

const URLLockGuard = ({ children }) => {
  const navigate = useNavigate();
  const lastValidPathRef = useRef(window.location.pathname);

  const handlePopState = () => {
    const current = window.location.pathname;
    const expected = lastValidPathRef.current;

    if (current !== expected) {
      navigate(expected, { replace: true });
    }
  };

  useEffect(() => {
    const path = stripPath(window.location.pathname);
    lastValidPathRef.current = path;
    window.history.replaceState(window.history.state, "", path + window.location.search + window.location.hash);
  });

  useEffect(() => {
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  });

  return children;
};

export default URLLockGuard;
